<div class="full-screen-slider-container" [style]="!active ? 'display: none' : ''" (click)="activate($event)">
    <div class="full-screen-slider" (wheel)="onWheel($event)"
        (mousedown)="onMouseDown($event)" (mouseup)="onMouseUp()" (mousemove)="onMouseMove($event)">
        <img (click)="clickPhoto($event)" [src]="getImageUrl(photo)" [ngStyle]="{'transform': transformStyle}" class="draggable-image"  alt="photo"/>
    </div>
    <div  class="full-screen-slider-container-button full-screen-slider-container-button-cross">
        <app-icon [icon]="Icons.cross"/>
    </div>
    <div (click)="onWheel($event, -0.1)" class="full-screen-slider-container-button full-screen-slider-container-button-magnifier-minus">
        <app-icon  [icon]="Icons.magnifirerMinus"/>
    </div>
    <div (click)="onWheel($event, 0.1)" class="full-screen-slider-container-button full-screen-slider-container-button-magnifier-plus">
        <app-icon [icon]="Icons.magnifirerPlus"/>
    </div>
    <div *ngIf="isArrow()" (click)="clickLeft($event)" class="full-screen-slider-container-button full-screen-slider-container-button-left">
        <div style="width: 40px; height: 40px;">
            <app-icon [icon]="Icons.buttonArrow"/>
        </div>
    </div>
    <div *ngIf="isArrow()" (click)="clickRight($event)" class="full-screen-slider-container-button full-screen-slider-container-button-right">
        <div style="width: 40px; height: 40px;">
            <app-icon [icon]="Icons.buttonArrow"/>
        </div>
    </div>
</div>
